export default "__VITE_ASSET__y5iz30hh__"